import { keyBy, get } from 'lodash';
import AppRouter from 'common/AppRouter';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

function useScrollToTopOnRouteChange(ref) {
  const history = useHistory();

  useEffect(() => {
    const unlisten = history.listen(() => {
      const routesByPath = keyBy(AppRouter, 'path');
      const viewPath = history.location.pathname.split('/')[1];

      const isScrollToTop = get(
        routesByPath,
        `[/${viewPath}].options.scrollToTop`,
        true
      );

      if (isScrollToTop) {
        ref?.current?.scrollTo(0, 0);
      }
    });
    return () => {
      unlisten();
    };
  }, [history]);
}

export default useScrollToTopOnRouteChange;
